'use strict';

import jQuery from 'jquery';
import cookie from './../../vendor/jquery.cookie.js';
import ga from './../../vendor/google-analytics';
import Core from './../Core/Core';

/**
 * SignIn
 *
 * JavaScript functions for the the Sign In page
 */
var SignIn = (function($) {
  return function(options) {

    // Namespace for private variables and functions
    var privateNS = {
      defaults: { // Namespace for default options
      }
    };

    // Namespace for public variables and functions
    var publicNS = {};

    /**
     * Construct a new instance
     */
    privateNS.init = function() {

      // Initialize options
      privateNS.options = $.extend({}, privateNS.defaults, options);

      // Create a reference to the UI container
      privateNS.$container = $(privateNS.options.container);

      // Create a reference to the remember me checkbox
      privateNS.$rememberMe = privateNS.$container.find('.passport-remember-me');

      // If the passport remember me checkbox is on the page, then trigger an
      // update to make sure an initial value is set
      if (privateNS.$rememberMe.length > 0) {

        // Trigger a manual update on the remember me cookie to make sure it
        // exists
        privateNS.updateRememberMeCookie(
          privateNS.$rememberMe.is(':checked')
        );
      }

      // Attach the sign in event handlers
      privateNS.attachHandlers();
    };

    /**
     * Switches the users remember me cookie to the passed in state. Either true
     * meaning that the user should be remembered, or false meaning that the
     * user should be forgotten after their session
     *
     * @param {boolean} state The state to set the remember me cookie to
     */
    privateNS.updateRememberMeCookie = function updateRememberMeCookie(state) {

      // Define the base cookie options for the remember me cookie. This cookie
      // does not seem to track on load unless the domain is explicitly passed in
      var options = {
        hostOnly: true,
        path: '/'
      };

      // If the state for the cookie is true, then set a long expiration date
      // for the cookie. The cookie plugin takes the expiration time in days
      options = $.extend({}, options, {
        expires: state === true ? 365 : ''
      });

      // Save the cookie to the users computer
      $.cookie(
        'passport_remember_me',
        privateNS.$rememberMe.is(':checked'),
        options
      );
    };

    /**
     * Handles change events of the remember me checkbox. Changes to the
     * checkbox track back to the cookie stored with the users browser
     *
     * @param {jQuery.event} $event The triggering jQuery event
     */
    privateNS.onRememberMeChange = function onRememberMeChange($event) {

      // When the remember checkbox state changes, update the tracking cookie to
      // the appropriate state.
      privateNS.updateRememberMeCookie(privateNS.$rememberMe.is(':checked'));
    };

    /**
     * Handles clicks on the sign in methods to track the usage of the various
     * service providers
     *
     * @param {jQuery.event} $event The triggering jQuery event
     */
    privateNS.onSigninMethodClick = function onSigninMethodClick($event) {

      // Extract the service provider from the link
      var signinService = $(this).attr('data-service');

      // Track the click event back to analytics with the selected service
      ga('send', 'event', 'Passport', 'Sign In Method', signinService);
    };

    /**
     * Attach the event handlers for the show / episode page
     */
    privateNS.attachHandlers = function() {

      // Bind the change event of the remember me button
      privateNS.$rememberMe.on(
        'change',
        privateNS.onRememberMeChange
      );

      // Bind the click events of the various sign in options
      privateNS.$container.on(
        'click',
        '.passport-signin-option',
        privateNS.onSigninMethodClick
      );
    };

    // Return a new instance
    return privateNS.init();
  };

})(jQuery);

export default SignIn